export default "__VITE_ASSET__DZZ_dK2q__"